import http from './axios'

const url = 'https://user.17track.net/userapi/call'

const baseParms = {
  version: 'm1.0',
  timeZoneOffset: new Date().getTimezoneOffset()
}

// 获取用户信息
export const GetUser = async () => {
  const result = await http.post(
    url,
    Object.assign({}, baseParms, {
      method: "GetUser",
      sourcetype: "0",
      param: {}
    })
  ) 
  // console.log('result', result)
  return result
}

// 退出登录
// 获取用户成员当前限制数量信息
export const LogOut = async () => {
  const result = await http.post(
    url,
    Object.assign({}, baseParms, {
      method: "Signout",
      sourcetype: '0',
      param: {}
    })
  ) 
  return result
}